<template>
    <div class="BookPreviewBox" ref="BookPreviewBox">
        <!-- 第一行 -->
        <el-row :gutter="20" type="flex" justify="center">
            <!-- <el-col :span="span" style="padding: 0.2rem;padding-top: 0;">
                <div class="grid-content bg-purple">
                   <div v-if="show" class="leftDisplay">
                        <div class="textBox">
                            <div v-show="show==1" class="cover" @click="onChangePage(2)">
                                <p class="cover-title">{{cover.bcn.b2tit}}</p>
                                <p class="cover-second">{{cover.bcn.b4tit}}</p>
                                <p class="cover-source">{{cover.bappe}}</p>
                            </div>
                            <div v-show="show==2">
                                <ul>
                                    <li class="catalogEl" v-for="(item,index) of treeata" :key="index" @click="onChangePage(3)">{{item.dirName}}</li>
                                </ul>
                            </div>
                            <p v-show="show==3" v-for="(item,index) of pList" :key="index" class="articleP" v-html="keyRegExp(item,item.ptext,keyWord)"></p>
                        </div>
                        <div class="link">
                            <el-link type="danger" @click="onTopPage">上一页</el-link>
                            <el-link type="danger" @click="onBottomPage">下一页</el-link>
                        </div>
                    </div>
                    <div v-else class="leftDisplay">
                        <no-data></no-data>
                    </div>
                </div>
            </el-col> -->
            <el-col :span="13" style="padding: 0.2rem;padding-top: 0;">
                <div class="grid-content bg-purple">
                   <div v-if="show" class="leftDisplay" :style="{fontSize: size + 'rem'}">
                        <!-- <div class="link">
                            <el-link type="danger" @click="onTopPage">上一页</el-link>
                            <el-link type="danger" @click="onBottomPage">下一页</el-link>
                        </div> -->
                        <div class="link" style="left: 0.1rem;">
                                <el-button type="info" icon="el-icon-arrow-left" circle @click="onTopPage"></el-button>
                        </div>
                        <div class="link" style="right: 0.1rem;">
                            <el-button type="info" icon="el-icon-arrow-right" circle @click="onBottomPage"></el-button>
                        </div>
                        <div style="position: absolute; top: 0; right: 0rem;">
                            <el-dropdown trigger="click" placement="bottom" @command="handleSetSize">
                                <span class="el-dropdown-link">
                                    字体大小<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item style="font-size: 0.24rem;" command="0.24">大</el-dropdown-item>
                                    <el-dropdown-item style="font-size: 0.18rem;" command="0.18">中</el-dropdown-item>
                                    <el-dropdown-item style="font-size: 0.14rem;" command="0.14">小</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <!--  v-html="text" -->
                        <div class="textBox">
                            <!-- {{item.ptext}} -->
                            <!-- <p v-for="(item,index) of pList" :key="index" class="articleP" v-html="item.ptext"></p> -->
                            <!-- 初始化时显示-封面(show:1/封面，2/目录，3/内容) -->
                            <!--  @click="onChangePage(2)" -->
                            <div v-show="show==1" class="cover">
                                <!-- 书名 -->
                                <p class="cover-title">{{cover.bcn.b2tit}}</p>
                                <!-- 简介 -->
                                <p class="cover-second">{{cover.bcn.b4tit}}</p>
                                <!-- 出版社 -->
                                <p class="cover-source">{{cover.bappe}}</p>
                            </div>
                            <!-- 版权页 -->
                            <div v-show="show==4">
                                <p class="articleP" v-for="(item,key,index) of banquanye.bcat" :key="index" v-html="item"></p>
                                <p class="articleP" v-for="(item,index) of banquanye.pcit" :key="index+'pcit'" v-html="item.ptext"></p>
                                <p class="articleP" v-for="(item,index) of banquanye.ptags" :key="index+'ptags'" v-html="item.ptext"></p>
                            </div>
                            <!-- 前言页 -->
                            <div v-show="show==5">
                                <p class="articleP">{{qianyanye.title}}</p>
                                <p class="articleP">{{qianyanye.inscription}}</p>
                                <p class="articleP" v-for="(item,index) of qianyanye.ptags" :key="index" v-html="item.ptext"></p>
                            </div>
                            <!-- 目录 -->
                            <div v-show="show==2">
                                <ul>
                                    <li class="catalogEl" v-for="(item,index) of treeata.ptags" :key="index" @click="onChangePage(3)" v-html="item.ptext"></li>
                                </ul>
                            </div>
                            <!-- <el-tree :data="treeata" :props="defaultProps" @node-click="handleNodeClick"></el-tree> -->
                            <!-- 内容 -->
                            <div v-show="show==3">
                                <!-- v-html="keyRegExp(item,item.b2Title,item.keyWord) || keyRegExp(item,item.ptext,item.keyWord)" -->
                                <!-- {{item.b2Title || item.ptext}} -->
                                <p v-for="(item,index) of pList.ptags" :key="index" class="articleP" v-html="keyRegExp(item,item.b2Title,item.keyWord) || keyRegExp(item,item.ptext,item.keyWord)"></p>
                            </div>
                            <!-- 封底 -->
                            <div v-show="show==6">
                                <p v-for="(item,index) of fengdi.ptags" :key="index" v-html="item.ptext"></p>
                            </div>
                        </div>

                    </div>
                    <div v-else class="leftDisplay">
                        <no-data></no-data>
                    </div>
                </div>
            </el-col>
            <el-col :span="11" v-if="span">
                <div class="grid-content bg-purple">
                    <el-row>
                        <el-col :span="24">
                            <!-- 知识展示 -->
                            <div class="DisplayBox">
                                <div class="title">本书知识网络</div>
                                <div class="InfoBox" style="padding: 0">
                                    <el-tabs style="height: 2.21rem;" v-model="active" type="border-card" v-if="List.length">
                                        <el-tab-pane v-for="(v, i) of List" :key="i" :name="'第' + (i + 1) + '章'" :label="'第' + (i + 1) + '章'">
                                            <el-tabs v-if="v.paragraphs && v.paragraphs.length" style="height: 1.5rem" v-model="subactive" tab-position="left" type="border-card">
                                                <el-tab-pane v-for="(item, index) of v.paragraphs" :key="index" :name="'第' + (index + 1) + '段'" :label="'第' + (index+1) + '段'">
                                                    <!--  {{'[第' + item.pageNum + '页]'}} -->
                                                    <div class="InfoCon" style="height: 1.3rem;overflow-y: scroll;">{{item.vparagraphText}}</div>
                                                </el-tab-pane>
                                            </el-tabs>
                                        </el-tab-pane>
                                    </el-tabs>
                                    <div class="NoDataBox" v-else style="">
                                        <no-data></no-data>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <!-- <right-display :content="allList" :active="active2" :subactive="subactive2"></right-display> -->
                            <div class="DisplayBox">
                                <div class="title">全库知识网络</div>
                                <div class="InfoBox" v-if="allList.length">
                                    <div class="swiper-container" id="Right">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide" v-for="i of Num" :key="i">
                                                <div class="RightInfoBox">
                                                    <div class="RightInfo" v-for="v of total" :key="v" v-if="allList[total*(i-1)+(v-1)]">
                                                        <!--  @click="changeList(total*(i-1)+(v-1))" -->
                                                        <div>
                                                            <img :src="allList[total*(i-1)+(v-1)].vpictureUrl"  @click="changeList(total*(i-1)+(v-1))" alt="">
                                                            <div class="RightInfo_title clamp" @click="Jump(allList[total*(i-1)+(v-1)].vproductId)">{{allList[total*(i-1)+(v-1)].vproductName}}</div>
                                                            <div class="RightInfo_subtitle clamp">{{allList[total*(i-1)+(v-1)].vproductDesc}}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="swiper-button-prev swiper-button-black"></div>
                                        <div class="swiper-button-next swiper-button-black"></div>
                                    </div>
                                </div>
                                <div class="NoDataBox NoDataBox2" style="height: 2rem;" v-else>
                                    <no-data></no-data>
                                </div>
                                <div class="InfoBox">
                                    <el-tabs style="height: 2.21rem;" v-model="active2" type="border-card" v-if="List2.length">
                                        <el-tab-pane v-for="(v, i) of List2" :key="i" :name="'第' + (i + 1) + '章'" :label="'第' + (i + 1) + '章'">
                                            <el-tabs v-if="v.paragraphs" style="height: 1.5rem" v-model="subactive2" tab-position="left" type="border-card">
                                                <el-tab-pane v-for="(item, index) of v.paragraphs" :key="index" :name="'第' + (index + 1) + '段'" :label="'第' + (index+1) + '段'">
                                                     <!-- {{'[第' + item.pageNum + '页]'}}s -->
                                                    <div class="InfoCon" style="height: 1.3rem;overflow-y: scroll;">{{item.vparagraphText}}</div>
                                                </el-tab-pane>
                                            </el-tabs>
                                            <div class="NoDataBox" style="height: 3rem;" v-else>
                                                <no-data></no-data>
                                            </div>
                                        </el-tab-pane>
                                    </el-tabs>
                                    <div class="NoDataBox" v-else style="">
                                        <no-data></no-data>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import NoData from './searchNo'
import Swiper from 'swiper'
export default {
    components: {
        NoData
    },
    data () {
        return {
            show: 0,
            currentPage: 0,
            // 封面
            cover: {
                bcn: {
                    b2tit: '',
                    b4tit: ''
                }
            },
            // 本书内容
            bookContentArr: '',
            // 版权页
            banquanye: {
                bcat: {},
                pcit: [],
                ptags: []
            },
            // 前言页
            qianyanye: {
                date: '',
                inscription: '',
                ptags: [],
                title: ''
            },
            // 正文内容
            zhengwen: {
                bindex: 1,
                keyWord: '',
                ptags: []
            },
            // 封底
            fengdi: {
                npIll: '',
                ptags: []
            },
            treeata: [],
            pList: [],
            keyWord: '',
            active: '第1章',
            subactive: '第1段',
            List: [],
            allList: [],
            List2: [],
            active2: '第1章',
            subactive2: '第1段',
            Num: 1,
            total: 3,
            span: false,
            size: '0.18'
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null;
    },
    created () {
        // 左侧内容
        this.onContentRes()
    },
    mounted () {
        this.$nextTick(() => {
            var swiper3 = new Swiper('#Right', {
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
        })
        window.onHover = this.onHover
    },
    watch: {
        $route(action){
            debugger;
            // 获取当前页的id
            this.VProductId = this.$route.query.VProductId;
            this.allList = [];
            this.List2 = [];
            this.keyWord = '';
            this.span = false
            this.onContentRes();
        }
    },
    methods: {
        handleSetSize(size) {
            this.size = size
        },
        // 左侧内容请求
        onContentRes () {
            this.axios.post(window.IPConfig.IP + '/parseXmlData?productId=' + this.$route.query.VProductId).then(res => {
            // this.axios.post(window.IPConfig.IP + '/parseBookXml?VProductId=' + this.$route.query.VProductId).then(res => {
                // console.log(res, '左侧XML')
                if (res.status == 200) {
                    if (res.data.status == 200) {
                        // this.show = 1;
                        // this.onArticleContentRes()
                        // // 封面赋值
                        // this.cover = res.data.obj.cover;
                        // // 目录拆分赋值
                        // let catalog = res.data.obj.dirctory.dirPtags;
                        // let catalogList = [];
                        // catalog.forEach(item => {
                        //     let catalogObj = {
                        //         dirName: ''
                        //     };
                        //     for(var key in item){
                        //         catalogObj.dirName = item[key];
                        //     }
                        //     catalogList.push(catalogObj)
                        // });
                        // this.treeata = catalogList;
                        let bookContentData = res.data.obj;
                        // 书本赋值
                        this.bookContentArr = bookContentData;
                        if(bookContentData && bookContentData.length>0){
                            // 遍历书本内容
                            bookContentData.forEach(item => {
                                for(let key in item){
                                    if(key == 'fengmian'){
                                        this.show = 1;
                                        // 封面赋值
                                        this.cover = item[key];
                                    }
                                }
                            })
                        }else{
                            console.log('无书本数据');
                        }
                    } else {
                        this.bookContentArr = [];
                        this.cover = {
                            bcn: {
                                b2tit: '',
                                b4tit: ''
                            }
                        },
                        this.treeata = []
                        this.show = 0
                        // this.$message.error(res.data.msg)
                    }
                }
            })
        },
        handleClick() {
            // this.subactive = '第1页'
        },
        // 请求文章内容
        onArticleContentRes (){
            this.axios.post(window.IPConfig.IP + '/bookParseData').then((response) => {
                // console.log(response,'请求文章内容')
                if (response.status == 200) {
                    // 文章内容
                    this.pList = response.data.rePtagList;
                    // 关键词
                    this.keyWord = response.data.keyWord;
                    // this.$emit('keyWord',this.keyWord)
                    this.onAllManage(this.keyWord);
                }
            });
        },
        // 第二行右侧
        onAllManage (keyWord){
            this.axios.post(window.IPConfig.IP + '/tBusParagraph/getAllResourceFromDB.do',
                {
                    "VChpterKeyWord": keyWord
                }
            ).then((response) => {
                if (response.status == 200) {
                    if (response.data.obj && response.data.obj.length) {
                        this.allList = response.data.obj;
                        if (this.allList.length / this.total < 1 && this.allList.length % this.total < this.total) {
                            this.Num = 1;
                        } else if (this.allList.length % this.total == 0) {
                            this.Num = this.allList.length / this.total;
                        } else {
                            this.Num = Math.ceil(this.allList.length / this.total);
                        }
                        this.List2 = this.allList[0].tbusChapterList
                        // this.active2 = this.allList[0].tbusChapterList[0].vchpterKeyWord;
                    }
                }
            });
        },
        changeList(index) {
            if(this.allList.length){
                this.List2 = this.allList[index].tbusChapterList
                // this.active2 = this.allList[index].tbusChapterList[0].vchpterKeyWord;
            }
        },
        // 本书知识点展示
        onHover (pInfo,keyWord){
            this.span = true
            this.axios.post(window.IPConfig.IP + '/tBusParagraph/getPraAndChapters.do',
                {
                    "VResourceId": pInfo,
                    "VParagraphKeeyWord": keyWord
                }
            ).then((response) => {
                // console.log(response, '文章点击')
                if (response.status == 200) {
                    if (response.data.obj && response.data.obj.length) {
                        this.List = response.data.obj;
                        this.onAllManage(keyWord);
                    }
                    // console.log(this.List);
                }
            });
        },
        Jump(VProductId) {
            if(VProductId == this.$route.query.VProductId){
                this.$message('此商品为当前商品')
            }else{
                this.$router.push({
                    path: 'fileInfo',
                    query: {
                        VProductId: VProductId
                    }
                })
            }
        },
        // 高亮
        keyRegExp (item,str,key){  // 搜索关键词高亮显示
            var ID = JSON.stringify(item.id);
            var keyWord = JSON.stringify(key);
            var str2 = ''
            if(str){
                if(key){
                    // 正则匹配中文、英文关键字高亮，高亮后的关键字和之前的大小写保持一致
                    var key  = key || '';//这里定义关键词
                    key = '('+key.replace(/([\+\.\*\|\?\-\(\[\^\$])/g,'\\$1' ).replace(/\s+/g,'|')+')';//把匹配关键字中的正则符转义
                    var patt = new RegExp(key ,'igm'); //传  igm  可避免关键词后面的空格造成文字不匹配问题
                    str2 = str.replace(patt,"<span style='color:#f00;cursor:pointer' onclick='onHover(" + ID + "," + keyWord + ")'>$1</span>");
                }else{
                     str2 = str
                }
            }
            return str2;
        },
        // 显示状态
        onChangePage (show){
            this.show = show;
        },
        // 上一页
        // onTopPage (){
        //     if(this.show < 2){
        //         this.show = 1;
        //         this.$message('已是第一页')
        //     }else{
        //         this.show--;
        //     }
        // },
        // // 下一页
        // onBottomPage (){
        //     if(this.show > 2){
        //         this.show = 3;
        //         this.$message('已是最后一页')
        //     }else{
        //         this.show++;
        //     }
        // }
        // 上一页
        onTopPage (){
            // if(this.show < 2){
            //     this.show = 1;
            //     this.$message('已是第一页')
            // }else{
            //     this.show--;
            // }
            if(this.currentPage < 1){
                this.show = 1;
                this.$message('已是第一页')
            }else{
                this.currentPage--;
                let nextPage = this.bookContentArr[this.currentPage];
                for(let key in nextPage){
                    switch (key){
                        case 'fengmian':
                            this.show = 1;
                            // 封面赋值
                            this.cover = nextPage[key];
                            break;
                        case 'banquanye':
                            this.show = 4;
                            // 封面赋值
                            this.banquanye = nextPage[key];
                            break;
                        case 'qianyanye':
                            this.show = 5;
                            // 封面赋值
                            this.qianyanye = nextPage[key];
                            break;
                        case 'mulu':
                            this.show = 2;
                            // 封面赋值
                            this.treeata = nextPage[key];
                            break;
                        case 'zhengwen':
                            this.show = 3;
                            // 封面赋值
                            this.pList = nextPage[key];
                            break;
                        case 'fengdi':
                            this.show = 6;
                            // 封面赋值
                            this.fengdi = nextPage[key];

                            break;
                    }
                }
            }
        },
        // 下一页
        onBottomPage (){
            // if(this.show > 2){
            //     this.show = 3;
            //     this.$message('已是最后一页')
            // }else{
            //     this.show++;
            // }
            // 判断当前页,遍历数组判断下一页应用哪个模版
            if(this.currentPage > this.bookContentArr.length-1){
                this.show = 1;
                this.$message('已是最后一页')
            }else{
                this.currentPage++;
                let nextPage = this.bookContentArr[this.currentPage];
                for(let key in nextPage){
                    switch (key){
                        case 'fengmian':
                            this.show = 1;
                            // 封面赋值
                            this.cover = nextPage[key];
                            break;
                        case 'banquanye':
                            this.show = 4;
                            // 封面赋值
                            this.banquanye = nextPage[key];
                            break;
                        case 'qianyanye':
                            this.show = 5;
                            // 封面赋值
                            this.qianyanye = nextPage[key];
                            break;
                        case 'mulu':
                            this.show = 2;
                            // 封面赋值
                            this.treeata = nextPage[key];
                            break;
                        case 'zhengwen':
                            this.show = 3;
                            // 封面赋值
                            this.pList = nextPage[key];
                            break;
                        case 'fengdi':
                            this.show = 6;
                            // 封面赋值
                            this.fengdi = nextPage[key];
                            break;
                    }
                }
            }

        }
    },

}
</script>

<style>
    .chart-container1 {
        position: relative;
        width: 100%;
        height: 5rem;
    }
    #chart {
        width: 100%;
        height: 100%;
    }
    .BookPreviewBox {
        margin-top: 0.2rem;
      margin-bottom: 100px;
    }
    .leftDisplay {
        border: 0.01rem solid #228457;
        /* height: 12.1rem; */
        height: 7.8rem;
        padding: 0.2rem;
        line-height: 1.5;
        /* font-size: 0.18rem; */
        position: relative;
    }
    .leftDisplay > .searchNoBox {
        margin: 0;
        height: 100%;
    }
    .leftDisplay > .searchNoBox > .searchNo_t {
        height: 100%;
        justify-content: center;
    }
    .leftDisplay > .searchNoBox > .searchNo_t img {
        width: 50%;
        margin-bottom: 0.3rem;
    }
    .leftDisplay .textBox {
        /* height: 11rem; */
        height: 95%;
        overflow-y: auto;
        margin: 0 0.6rem;
    }
    .leftDisplay .link {
        /* width: 100%; */
        position: absolute;
        top: 45%;
        /* left: 0.2rem;
        top: 0.2rem;
        font-size: 0.16rem;
        display: flex;
        justify-content: space-around; */
    }
    .leftDisplay .link .el-link {
        font-size: 0.16rem;
    }
    /* 第一行右侧 */
    .DisplayBox > .title {
        margin-bottom: 0.1rem;
        border-left: 3px solid #00ae80;
        padding-left: 0.06rem;
        margin-top: .1rem;
    }
    .DisplayBox .InfoBox > img {
        width: 100%;
    }
    /* 文章内容 */
    .articleP{
        text-indent: 2em;
    }
    /* 内容封面 */
    .cover{
        text-align: center;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .cover-title{
        font-size: .6rem;
    }
    .cover-second{
        font-size: .4rem;
        margin-bottom: 2rem;
    }
    .cover-source{
        /* margin-top: 5rem; */
    }
    .catalogEl{
        line-height: 2;
    }
    .NoDataBox .searchNoBox {
        margin: 0;
        height: 2.21rem;
        padding: 0;
        justify-content: center;
    }
    /* .NoDataBox2 .searchNoBox {
        height: 1.2rem;
    } */
    .NoDataBox .searchNoBox .searchNo_t {
        justify-content: center;
    }
    .NoDataBox .searchNo_t > img {
        width: 18%;
        margin-bottom: 0.2rem;
    }
    #Right {
        height: 2rem;
        margin-top: 0;
        background: #fff;
    }
    .RightInfoBox {
        width: 88%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .RightInfoBox .RightInfo {
        width: calc(100% / 3);
        padding: 0.1rem;
    }
    .RightInfoBox .RightInfo > div {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        cursor: pointer;
    }
    .RightInfoBox .RightInfo > div:hover {
        box-shadow: 0 0 0.2rem #ccc;
    }
    .RightInfoBox .RightInfo > div img {
        width: 1rem;
    }
    .RightInfoBox .RightInfo > div div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .RightInfoBox .RightInfo > div div.RightInfo_title {
        font-size: 0.16rem;
        font-weight: bold;
        text-align: center;
    }
    .RightInfoBox .RightInfo > div span {
        font-size: 0.18rem;
        font-weight: bold;
        color: red;
    }
</style>



// WEBPACK FOOTER //
// src/components/ivew/replatioDetail.vue